const hasBearerToken = (token) => typeof token === 'string' && token.trim();

export const buildBearerAuthHeaders = (token) =>
  hasBearerToken(token) ? { Authorization: `Bearer ${token}` } : {};

export const buildJsonAuthHeaders = (token) => ({
  'Content-Type': 'application/json',
  ...buildBearerAuthHeaders(token),
});
